import { render, staticRenderFns } from "./AreaTotal.vue?vue&type=template&id=f1291034"
import script from "./AreaTotal.vue?vue&type=script&lang=js"
export * from "./AreaTotal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports